<template>
    <div>
        <div class="py-3" style="">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="d-flex justify-content-center">Import Foreign/Other US Per Diem</h1>
                        <b-form-group size="sm" class="d-flex justify-content-center">
                            <b-form-radio-group id="btn-radios-1"
                                                v-model="toggleSelectedValue"
                                                :options="optionsLink"
                                                buttons
                                                @change="toggleChanged($event)"
                                                name="radios-btn-default">
                            </b-form-radio-group>
                        </b-form-group>
                        <div v-if="inProgress" class="container">
                            <b-spinner class="center-spinner mt-5" variant="primary" label="Spinning"></b-spinner>
                        </div>
                        <div v-show="!inProgress" style="text-align:center;">
                            <div v-if="displayForm == 'foreign'">
                                <div v-if="filesHasError" class="alert alert-danger">
                                    <ul style="text-align:center; margin-bottom:0;">
                                        <li v-for="file in files" :key="file.id">
                                            <span v-if="file.error">Error uploading file: {{file.name}}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="example-simple">
                                    <div class="upload">
                                        <div class="upload-button">
                                            <file-upload class="btn btn-primary upload-button"
                                                         :post-action="this.foreignPostURL"
                                                         extensions="csv"
                                                         accept="text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                         :multiple="false"
                                                         :headers="{'Authorization': 'Bearer ' + this.msal.accessToken}"
                                                         v-model="files"
                                                         input-id="file1"
                                                         @input-filter="inputFilter"
                                                         @input-file="inputFile"
                                                         :drop="true"
                                                         ref="upload">
                                                <i class="fa fa-plus"></i>
                                                Select Foreign Per Diem File
                                            </file-upload>
                                            <button type="button" class="btn btn-success upload-button" style="display:none;" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true">
                                                <i class="fa fa-arrow-up" aria-hidden="true"></i>
                                                Start Upload
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="displayForm == 'otherus'">
                                <div v-if="otherFilesHasError" class="alert alert-danger">
                                    <ul style="text-align:center; margin-bottom:0;">
                                        <li v-for="otherFile in otherFiles" :key="otherFile.id">
                                            <span v-if="otherFile.error">Error uploading file: {{otherFile.name}}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="example-simple">
                                    <div class="upload">
                                        <div class="upload-button">
                                            <file-upload class="btn btn-primary upload-button"
                                                         :post-action="this.otherDoemsticPostURL"
                                                         extensions="csv"
                                                         accept="text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                         :multiple="false"
                                                         :headers="{'Authorization': 'Bearer ' + this.msal.accessToken}"
                                                         v-model="otherFiles"
                                                         input-id="otherFile"
                                                         @input-filter="inputOtherFilter"
                                                         @input-file="inputOtherFile"
                                                         :drop="true"
                                                         ref="otherUpload">
                                                <i class="fa fa-plus"></i>
                                                Select Other Domestic Per Diem File
                                            </file-upload>
                                            <button type="button" class="btn btn-success upload-button" style="display:none;" v-if="!$refs.otherUpload || !$refs.otherUpload.active" @click.prevent="$refs.otherUpload.active = true">
                                                <i class="fa fa-arrow-up" aria-hidden="true"></i>
                                                Start Upload
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button class="btn btn-primary mt-3" @click="getTemplate()">Download Template</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    ul {
        list-style: none;
    }

    .upload-button {
        margin-top: 10px;
    }

    .thumbnail-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .example-simple label.btn {
        margin-bottom: 0;
        margin-right: 1rem;
    }

    input:disabled {
        background: none;
    }

    .card-styling {
        border: 1px solid #151616;
        border-radius: 3px;
        margin-bottom: 20px;
        margin-right: 20px;
    }

        .card-styling:hover {
            border: 2px solid #12bbad;
            margin-bottom: 17px;
            margin-right: 17px;
        }

    .icons {
        color: grey;
        cursor: pointer;
        font-size: 1.25em;
    }

        .icons:hover {
            color: #12bbad;
        }

    svg:hover {
        fill: red;
    }

    .card-description {
        border-top: 1px solid #d0d2d7;
        height: 95px;
        max-width: 125px;
        text-align: center;
    }

    .img-center-vertically {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .img {
        width: 125px;
        max-height: 150px;
        cursor: pointer;
    }

    .receipt-name {
        max-height: 3.3em;
        overflow: hidden;
        font-weight: 500;
        font-size: smaller;
    }
</style>
<script>
    import FileUpload from 'vue-upload-component'

    export default {
        name: "import-foreign-other-per-diem",
        components: {
            FileUpload
        },
        data() {
            return {
                files: [],
                otherFiles: [],
                displayForm: "foreign",
                foreignPostURL: this.$hostname + 'locations/foreign/perdiem',
                otherDoemsticPostURL: this.$hostname + 'locations/otherdomestic/perdiem',
                inProgress: false,
                toggleSelectedValue: "foreign",
                optionsLink: [
                    { text: 'Foreign', value: 'foreign' },
                    { text: 'Other US', value: 'otherus' }
                ],
            }
        },
        computed: {
            otherFilesHasError: function() {
                for (var i = 0; i < this.otherFiles.length; i++) {
                    if (this.otherFiles[i].error) {
                        return true;
                    }
                }
            },
            filesHasError: function() {
                for (var i = 0; i < this.files.length; i++) {
                    if (this.files[i].error) {
                        return true;
                    }
                }
            }
        },
        async beforeMount() {
        },
        methods: {
            toggleChanged(ev) {
                if (ev == "otherus") {
                    this.$refs.upload.clear();
                    this.displayForm = "otherus";
                }
                else {
                    this.$refs.otherUpload.clear();
                    this.displayForm = "foreign";
                }
            },
            //sanitize input filter for upload client side
            inputFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    // Before adding a file
                    // Filter system files or hide files
                    if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                        return prevent()
                    }
                    // Filter php html js file
                    if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                        return prevent()
                    }
                }
            },

            //event triggers on upload
            inputFile(newFile, oldFile) {
                if (newFile && oldFile) {
                    if (newFile && !oldFile) {
                        // add
                    }
                    if (newFile && oldFile) {
                        // update
                    }
                    if (!newFile && oldFile) {
                        // remove
                        return;
                    }
                    // Uploaded successfully
                    if (newFile.success !== oldFile.success) {
                        this.$notify({
                            group: 'success',
                            type: 'success',
                            title: 'Sucess',
                            text: "Foreign Per Diems updated."
                        });
                        this.inProgress = false;
                        this.$refs.upload.clear();
                    }

                    if (newFile.error) {
                        this.inProgress = false;
                    }
                }

                // Automatically activate upload
                if (newFile && newFile !== oldFile || oldFile.error !== newFile.error) {
                    if (!this.$refs.upload.active) {
                        this.$refs.upload.active = true
                        this.inProgress = true;
                    }
                }

            },
            //sanitize input filter for upload client side
            inputOtherFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    // Before adding a file
                    // Filter system files or hide files
                    if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                        return prevent()
                    }
                    // Filter php html js file
                    if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                        return prevent()
                    }
                }
            },

            //event triggers on upload
            inputOtherFile(newFile, oldFile) {
                if (newFile && oldFile) {
                    if (newFile && !oldFile) {
                        // add
                    }
                    if (newFile && oldFile) {
                        // update
                    }
                    if (!newFile && oldFile) {
                        return;
                    }
                    // Uploaded successfully
                    if (newFile.success !== oldFile.success) {
                        this.$notify({
                            group: 'success',
                            type: 'success',
                            title: 'Sucess',
                            text: "Other Domestic Per Diems updated."
                        });
                        this.inProgress = false;
                        this.$refs.otherUpload.clear();

                    }

                    if (newFile.error) {
                        this.inProgress = false;
                    }
                }

                // Automatically activate upload
                if (newFile && newFile !== oldFile || oldFile.error !== newFile.error) {
                    if (!this.$refs.otherUpload.active) {
                        this.$refs.otherUpload.active = true
                        this.inProgress = true;
                    }
                }

            },
            getTemplate() {
                this.$http
                    .get(`Locations/PerDiem/Template`, {
                        responseType: 'blob',
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then((response) => {
                        const file = new Blob(
                            [response.data],
                            { type: response.headers['content-type'] });
                        var anchorTag = document.createElement("a");
                        anchorTag.style = "display: none;";
                        document.body.appendChild(anchorTag);

                        const downloadUrl = window.URL.createObjectURL(file);
                        anchorTag.href = downloadUrl;
                        anchorTag.download = 'PerDiemTemplate.csv';
                        anchorTag.click();
                        window.URL.revokeObjectURL(downloadUrl);
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: "An error occurred downloading the template."
                        });
                    })
            }
        }
    }
</script>
